import { Component } from '@angular/core';
import { NewsModel } from '../../../shared/models/news.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FilterModel } from '../../../shared/interface/interface';
import { ScrollDisableService } from '../../../shared/services/scroll-disable.service';
import { SkeletonLoaderComponent } from '../../../shared/components/skeleton/skeleton.component';
import { NewsCardComponent } from '../news-card/news-card.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { ConfirmationModalComponent } from '../../../shared/components/confirmation-modal/confirmation-modal.component';
import { SharedModule } from '../../../shared/shared.module';
import { NewsService } from '../../../shared/services/news.service';
import { ToastrService } from 'ngx-toastr';
import { DEFAULT_FILTER } from '../../../shared/constants/constants';

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [
    SharedModule,
    SkeletonLoaderComponent,
    NewsCardComponent,
    PageHeaderComponent,
    ConfirmationModalComponent,
  ],
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss',
})
export class NewsComponent {
  newsList: NewsModel[] = [];
  totalNewsRecords = 0;
  deleteNewsId!: string | undefined;
  newsListLoading: boolean = true;
  subscription: Subscription = new Subscription();
  private newsFilterSubject$: BehaviorSubject<FilterModel> =
    new BehaviorSubject<FilterModel>(DEFAULT_FILTER);
  totalNews: number = 0;
  newsFilter = this.newsFilterSubject$.asObservable();
  menuOpenIndex = -1;
  deleteLoading: boolean = false;
  constructor(
    private readonly scrollDisableService: ScrollDisableService,
    private readonly newsService: NewsService,
    private readonly toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.init();
  }
  init() {
    const sub = this.newsFilterSubject$.subscribe((value: FilterModel) => {
      this.getNewsList(value);
    });
    this.subscription.add(sub);
    // this.subscribeToCategoryFormValueChange();
  }

  onDeleteNews(id: string) {
    this.deleteNewsId = id;
    this.scrollDisableService.stopScroll();
  }

  deleteNews() {
    if (this.deleteNewsId) {
      this.deleteLoading = true;
      this.newsService.deleteNews(this.deleteNewsId).subscribe({
        next: (res) => {
          this.deleteLoading = false;
          this.deleteNewsId = undefined;
          this.updateNewsFilter(DEFAULT_FILTER);
          this.toastr.success('News deleted successfully.');
          this.scrollDisableService.addScroll();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error(
            err?.error?.message || err?.message || 'Something went wrong!'
          );
          this.scrollDisableService.addScroll();
          this.deleteLoading = false;
        },
      });
    }
  }
  cancelDelete() {
    this.deleteNewsId = undefined;
    this.scrollDisableService.addScroll();
  }
  getNewsList(value: FilterModel) {
    this.newsListLoading = true;
    this.newsService.fetchNewsList(value).subscribe({
      next: (res: any) => {
        this.newsList =
          value.pageNumber > 1 ? [...this.newsList, ...res.result] : res.result;
        this.totalNewsRecords = res.count;
        this.newsListLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
        this.newsListLoading = false;
      },
    });
  }

  loadMoreIfLastIndex() {
    const { searchText, pageNumber, limit } = this.newsFilterSubject$.value;
    if (pageNumber * limit < this.totalNewsRecords) {
      this.updateNewsFilter({
        searchText,
        limit,
        pageNumber: pageNumber + 1,
      });
    }
  }

  updateNewsFilter(filter: FilterModel) {
    this.newsFilterSubject$.next(filter);
  }
  closeAllMenu(index: number) {
    if (index === this.menuOpenIndex) {
      this.menuOpenIndex = -1;
    }
  }
  openMenu(index: number) {
    this.menuOpenIndex = index;
  }
  handleSearch(searchText: string) {
    if (searchText.length === 0 || searchText?.trim()) {
      this.updateNewsFilter({
        ...this.newsFilterSubject$.value,
        pageNumber: 1,
        searchText: searchText,
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.scrollDisableService.addScroll();
  }
}
